export const TOGGLE_NEW_EXPERIENCE_MODAL = 'TOGGLE_NEW_EXPERIENCE_MODAL';
export const CREATE_EXPERIENCE_REQUEST = 'CREATE_EXPERIENCE_REQUEST';
export const FETCH_EXPERIENCE_REQUEST = 'FETCH_EXPERIENCE_REQUEST';
export const FETCH_EXPERIENCES_REQUEST = 'FETCH_EXPERIENCES_REQUEST';
export const UPDATE_EXPERIENCE_REQUEST = 'UPDATE_EXPERIENCE_REQUEST';
export const SET_EXPERIENCE_LENGTH = 'SET_EXPERIENCE_LENGTH';
export const UPDATE_TOUR_STEP_FORM = 'UPDATE_TOUR_STEP_FORM';
export const CREATE_PHOTO_REQUEST = 'CREATE_PHOTO_REQUEST';
export const REMOVE_PHOTO_REQUEST = 'REMOVE_PHOTO_REQUEST';
export const MOVE_PHOTO_REQUEST = 'MOVE_PHOTO_REQUEST';
export const TOGGLE_CHANGES_MODAL = 'TOGGLE_CHANGES_MODAL';
export const MOBILE_TABS_MENU_TOGGLED = 'MOBILE_TABS_MENU_TOGGLED';
export const REQUEST_STEP_SELECTED = 'REQUEST_STEP_SELECTED';
export const LOCATION_SEARCHED = 'LOCATION_SEARCHED';
export const LOCATION_SELECTED = 'LOCATION_SELECTED';
export const UPDATE_EXPERIENCE_ERRORS_ACKNOWLEDGED =
  'UPDATE_EXPERIENCE_ERRORS_ACKNOWLEDGED';
export const CREATE_EXPERIENCE_MEETING_REQUEST =
  'CREATE_EXPERIENCE_MEETING_REQUEST';
export const CREATE_EXPERIENCE_MEETING_SUCCESS =
  'CREATE_EXPERIENCE_MEETING_SUCCESS';
export const UPDATE_EXPERIENCE_MEETING_REQUEST =
  'UPDATE_EXPERIENCE_MEETING_REQUEST';
export const UPDATE_EXPERIENCE_MEETING_SUCCESS =
  'UPDATE_EXPERIENCE_MEETING_SUCCESS';
